import { render } from "./MainLayout.vue?vue&type=template&id=319524f5&scoped=true"
const script = {}

import "./MainLayout.vue?vue&type=style&index=0&id=319524f5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-319524f5"]])

export default __exports__